import type { ISbStoryData } from 'storyblok-js-client';

/**
 * This function makes resolved relations a little easier to work with, developer experience wise
 * When you have a relation in Storyblok that you resolve via the `resolve_relations` option, the generated type will be something like the following:
 * ```ts
 * export interface Blok {
 *   potential_relation?: (ISbStoryData<Relation> | string)[];
 * }
 * ```
 * However, with `resolve_relations` you can pretty much assume that it ends up being `ISbStoryData<Relation>`
 * This utility does the necessary conditional handling to make sure you can assume that fact
 *
 * Use it like so:
 * @example
 * ```ts
 * const resolvedRelation = resolveRelations(Blok.potential_relation);
 * ```
 *
 * The resulting type will be `ISbStoryData<Relation>`
 */
export function resolveRelations<T>(potentialRelations: (string | ISbStoryData<T>)[] | undefined) {
  if (potentialRelations === undefined) return [];

  return potentialRelations.filter((potentialRelation) => typeof potentialRelation !== 'string');
}

export function resolveRelation<T>(potentialRelations: string | ISbStoryData<T> | undefined) {
  if (potentialRelations === undefined) return undefined;
  return typeof potentialRelations === 'string' ? undefined : potentialRelations;
}
